module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_j_albino.a2c779b6.png";